import axios from "@/plugins/axios";

let url = "/api/v1/me/purchase-orders";

export default {
    post(data) {
        return axios.post(`${url}/${data._order}/claims`, data).then((result) => result.data);
    },
};
